<template>
  <section class="warning-boxes">
    <warning-box-chrome />
  </section>
</template>

<script>
  import {mapGetters} from 'vuex'
  import WarningBoxChrome from "@/components/warningbox/WarningBoxChrome";
  export default {
    name: "WarningBoxes",
    components: {WarningBoxChrome},
    data() {
      return {
      }
    },
    created(){
    },
    computed: {
      ...mapGetters(['userData']),
    }
  }
</script>


<style lang="scss">
  @import "../../scss/theme";
  .warning-boxes {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 214748460;
    width: 100%;
    margin: 0;
    padding: 0;
    color: white;
    font-weight: 300;
    &:empty {
      display: none;
    }
    & > div {
      width: 100%;
      padding: 10px 12px;
      background-color: $c-secondary;
      box-shadow: 0 0 24px #00000050;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 8px 8px 0 0;
      a.btn--primary {
        line-height: 32px;
        &:hover {
          color: white;
        }
      }
      .btn--ternary.btn--outline {
        background-color: white;
      }
    }
  }
</style>
